(function () {
  "use strict";

  var mq = window.matchMedia("(min-width: 990px)");
  var accordions = document.querySelectorAll(".footer-accordion");
  if (!accordions.length) return;

  function forceOpenOnDesktop() {
    if (!mq.matches) return;
    accordions.forEach(function (details) {
      details.setAttribute("open", "");
    });
  }

  accordions.forEach(function (details) {
    var summary = details.querySelector("summary");
    if (!summary) return;
    summary.addEventListener("click", function (e) {
      if (mq.matches) e.preventDefault();
    });
  });

  forceOpenOnDesktop();
  mq.addEventListener
    ? mq.addEventListener("change", forceOpenOnDesktop)
    : mq.addListener(forceOpenOnDesktop);
})();


(function () {
  const form = document.getElementById('footer-subscribe-form');
  const input = document.getElementById('footer-subscribe-email');
  const msg = document.getElementById('footer-subscribe-msg');

  if (!form) return;

  const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  let hideTimer = null;

  function showMessage(text, isError) {
    clearTimeout(hideTimer);
    msg.textContent = text;
    msg.classList.toggle('error', isError);
    msg.classList.add('show');
    hideTimer = setTimeout(() => {
      msg.classList.remove('show');
    }, 3000);
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    const email = input.value.trim();

    if (!EMAIL_RE.test(email)) {
      input.classList.add('is-invalid');
      showMessage('Please enter a valid email address', true);
      return;
    }

    input.classList.remove('is-invalid');

    // Replace this block with your actual subscribe API call
    // fetch('/subscribe', { method: 'POST', body: JSON.stringify({ email }) })

    showMessage("You're subscribed!", false);
    form.reset();
  });

  input.addEventListener('input', function () {
    input.classList.remove('is-invalid');
  });
})();